import moment from 'moment';
import { Link } from 'react-router-dom';
import userlogo from '../../assets/user.png';

/*
 * Styles : mc-account-requests.css (importé par la page qui liste les messages).
 */

function MessageItem({ data }) {
  const missingInviteDocs = !data?.Invite?.PermisConduireDoc || !data?.Invite?.PieceIdentityDoc;

  const guestName = `${data?.Invite?.firstName || ''} ${data?.Invite?.lastName || ''}`.trim();
  const vehicleLabel = [data?.Vehicle?.VehicleModel?.marque, data?.Vehicle?.VehicleModel?.modele]
    .filter(Boolean)
    .join(' ');

  return (
    <Link to={'/inbox/messages/thread/' + data.reservationId} className="mc-req-item">
      <img
        src={data?.Invite?.profile_url || userlogo}
        alt=""
        className="mc-req-avatar mc-req-avatar--round"
        width="56"
        height="56"
        loading="lazy"
      />

      <div className="mc-req-body">
        {vehicleLabel && <p className="mc-req-kicker">Voyage · {vehicleLabel}</p>}

        <p className="mc-req-title">
          {guestName || 'Conversation'}
          {missingInviteDocs && (
            <span className="mc-req-badge mc-req-badge--warn">
              <i className="bi bi-exclamation-triangle-fill" aria-hidden="true"></i>
              Docs manquants
            </span>
          )}
        </p>

        {data?.Vehicle?.description && (
          <p className="mc-req-text mc-req-text--clamp">{data.Vehicle.description}</p>
        )}
      </div>

      <div className="mc-req-side">
        <span>{moment(data.createdAt).calendar()}</span>
        <i className="bi bi-chevron-right mc-req-chevron" aria-hidden="true"></i>
      </div>
    </Link>
  );
}

export default MessageItem;
